<template>
    <div>
        <div class="content content_he" style="padding:0.3rem;margin-top: .4rem;">
            <h3>这个结果页对你有帮助吗</h3>
            <span class="content_hes">考试真题及题型均为新百易考生回忆版，如有漏误，欢迎指出</span>
            <div class="content_help" style="display: flex;margin-top: .22rem;justify-content: space-between;">
            <div style="margin: 0 auto;display: flex;" v-if="hua_show"  @click="istsolclick()">
                <i class="back">
                <img style="width: .42rem; height: .65rem;margin: 0 auto;display: block;margin-top: .12rem;" src="@/assets/img/xhua_2.png" />
                </i>
                <div style="margin: 0 auto;line-height: .45rem;margin-left: .22rem;margin-top: .05rem;">
                    <div style="margin: 0 auto;line-height: .6rem;font-size: .3rem;color: #333333;height: .35rem;text-align: left;">送花鼓励</div>
                    <div style="margin: 0 auto;line-height: .6rem;font-size: .25rem;color: #595959;height: .35rem;text-align: left;width: 2rem;">已有{{like}}人送花</div>
                </div>
            </div>
            <div style="margin: 0 auto;display: flex;" v-else>
                <i class="back">
                <img style="width: .42rem; height: .65rem;margin: 0 auto;display: block;margin-top: .12rem;" src="@/assets/img/xhua_2_active.png" />
                </i>
                <div style="margin: 0 auto;line-height: .45rem;margin-left: .22rem;margin-top: .05rem;">
                <div style="line-height: .35rem;font-size: .3rem;color: #FFF;height: .35rem;text-align: center;background-color: #D83128;border-radius: .24rem;margin-top: .13rem;max-width:1rem;margin-top:.1rem">{{ likes + 1 }}</div>
                <div style="margin: 0 auto;line-height: .4rem;font-size: .25rem;color: #595959;height: .3rem;text-align: left;width: 2rem;">送花成功</div>
                </div>
            </div>
            <div style="margin: 0 auto;display: flex;"  @click="centerDialogVisiblestol = true">
                <i class="back">
                <img style="width: .45rem; height: .65rem;margin: 0 auto;display: block;margin-top: .12rem;" src="@/assets/img/xhua_1.png" />
                </i>
                <div style="margin: 0 auto;line-height: .45rem;margin-left: .22rem;margin-top: .05rem;">
                <div style="margin: 0 auto;line-height: .6rem;font-size: .3rem;color: #333333;height: .35rem;stext-align: left;">给出建议</div>
                <div style="margin: 0 auto;line-height: .6rem;font-size: .25rem;color: #595959;height: .35rem;text-align: left;">火速修改</div>
                </div>
            </div>
            </div>
        </div>
        
        <div class='modekskcl' @mousedown='fai_ku($event)'>
            <!-- <img src="@/assets/img/icon_01.png" /> -->
            <span>问题反馈</span>
        </div>

        <van-popup v-model="centerDialogVisiblestol" round >
            <div class="popup_show">
                <van-icon name="cross" @click="centerDialogVisiblestol = false"/>
                <h3>反馈与建议</h3>
                <div class="popup_show_title">
                    请描述你遇到的问题类型 
                    <span>（可多选）</span>
                </div>
                <div class="popup_show_multiples">
                    <div v-for='(item,index) in activlist' :key='index' :class="item.activfla == true ? 'active' : ''" @click="activeiclick(index)"> {{ item.name }}</div>
                </div>
                <div class="popup_show_title">
                    请描述你的问题 
                </div>
                <div class="popup_show_multiples">
                    <van-field v-model="suggestions" rows="4" autosize type="textarea" placeholder="请输入你的问题" style="width:100%"/>
                </div>
                <div class="popup_show_title">
                    请上传图片 
                    <span>（最多上传8张）</span>
                </div>
                <div class="popup_show_multiples">
                    <el-upload
                    style="width:100%;background:#FFF;text-align:left"
                    action="#"
                    accept=".jpg,.jpeg,.png,.JPG,.JPEG"
                    list-type="picture-card"
                    :limit="8"
                    :auto-upload="false"
                    :multiple="true"
                    :on-change="beforeRead">
                    <i class="el-icon-plus"></i>
                    </el-upload>
                </div>

                <div class="popup_show_button" @click="onsmit">提交</div>
            </div>
        </van-popup>
    </div>
</template>

<script>
import Vue from 'vue'
import { Popup } from 'vant'
Vue.use(Popup);

  export default {
    name: "Results",
    data() {
      return {
        hua_show: true,
        likes: 0,
        activlist:[
            {name:'题型/分值有误', activfla: true, id:1},
            {name:'难度有误', activfla: false, id:2},
            {name:'题目有误', activfla: false, id:3},
            {name:'其他问题', activfla: false, id:4},
        ],
        centerDialogVisiblestol: false,
        suggestions: '',
        fileList: [],
        suggestions_type:[]
      };
    },
    props:['like', 'api_token', 'agency_id', 'id', 'is_like'],
    created() {
      
    },
    watch:{
      is_like(val) {
        if(val == 1) {
          this.hua_show = false
        }
      }
    },
    methods:{
      fai_ku() {
          this.centerDialogVisiblestol = true
      },
        onsmit() {
            var formData = new FormData();
            formData.append('token', this.api_token)
            formData.append('agency_id', this.agency_id)
            formData.append('suggestions', this.suggestions)
            formData.append('pagelink', window.location.href)
            if(this.id == 0) {
              formData.append('district_id', localStorage.getItem('district_id'))
              formData.append('district', localStorage.getItem('district'))
              formData.append('subject', localStorage.getItem('subject'))
              formData.append('subject_id', localStorage.getItem('subject_id'))
              formData.append('district_and_county_id', localStorage.getItem('district_and_county_id'))
              formData.append('district_and_county', localStorage.getItem('district_and_county'))
              formData.append('year', localStorage.getItem('year'))
            }else {
              formData.append('id', this.$route.query.id)
            }
            
            this.activlist.forEach((item,index)=> {
                if(item.activfla == true ) {
                    formData.append('suggestions_type[' + index + ']',item.id)
                }
            })
            this.fileList.forEach((item,index) => {
                formData.append('files['+ index +']', item.raw )
            })
            this.$axios.post( 'saveSuggestions', formData, {
              headers: {
                'Content-Type': 'multipart/form-date'
              }
            })
            .then(res => {
                if(res.code == 200) {
                  this.centerDialogVisiblestol = false
                  this.$toast(res.message)
                }else {
                  this.$toast(res.message)
                }
            });
        },
        //点击多选
        activeiclick(i) {
            if (this.activlist[i].activfla == true) {
                this.activlist[i].activfla = false;
            } else {
                this.activlist[i].activfla = true;
            }
            var listt = [];
            this.activlist.forEach((item, i) => {
                if (item.activfla) {
                    listt.push(item);
                    this.suggestions_type.push(item.id)
                }
            });
            if (listt.length < 1) {
                this.$toast('最后一个了');
                this.activlist[i].activfla = true;
            }
        },
        //点击送花
        istsolclick() {
          var id = 0
            if(this.id == undefined) {
              id = 0
            }else {
              id = this.id
            }
            this.likes = this.like
            this.$axios.get('textpaperLike', {params:{
                token: this.api_token,
                agency_id: this.agency_id,
                id: id
            }},).then((d)=> {
                if(d.code == 200) {
                    if(d.message != '取消点赞') {
                      this.hua_show = false
                      this.$toast('送花成功')
                    }else {
                      this.hua_show = true
                      this.$toast('取消送花')
                    }
                }else {
                    this.$toast(d.message)
                }
            }).catch((err) => {
                this.$toast(err)
            });
        },
        beforeRead(file,filelist) {
            this.fileList.push(file)
        },
    },
    mounted() {
     
    },
    components: {
    },
  };
</script>

<style lang="less" scoped>
/deep/ .el-upload--picture-card {
    width: 1.2rem;
    height: 1.2rem;
    line-height: 1.2rem;
}

/deep/ .el-upload-list--picture-card .el-upload-list__item {
    width: 1.2rem;
    height: 1.2rem;
    line-height: 1.2rem;
}

.popup_show {
    width: 6rem;
    position: relative;
    padding-top: .6rem;
    padding-bottom: .3rem;
    > i {
        font-size: .4rem;
        position: absolute;
        right: .3rem;
        top: .3rem;
    }
    > h3 {
        font-size: .4rem;
        text-align: center;
    }

    .popup_show_title {
        font-size: 0.29rem;
        font-weight: 600;
        padding: 0 .3rem;
        color: rgb(75, 75, 75);
        > span {
            font-size: 0.22rem;
            color: rgb(75, 75, 75);
        }
    }

    .popup_show_multiples{
        display: flex;
        -webkit-box-pack: justify;
        justify-content: space-between;
        flex-wrap: wrap;
        margin-top: 0.3rem;
        padding: 0 .3rem;
        > div {
            width: 48%;
            line-height: 0.6rem;
            margin-bottom: 0.25rem;
            font-size: 0.21rem;
            text-align: center;
            background: rgb(241, 241, 241);
            border-radius: 6px;
        }

        > .active {
            color: rgb(255, 255, 255);
            background: rgb(123, 160, 255);
        }
    }

    .popup_show_button {
        width: 1.94rem;
        height: 0.56rem;
        background: linear-gradient(90deg, rgb(156, 186, 255) 0%, rgb(122, 159, 255) 100%);
        border-radius: 28px;
        font-size: 0.26rem;
        color: rgb(255, 255, 255);
        line-height: 0.56rem;
        text-align: center;
        margin: 0.4rem auto 0px;
    }
}

.login_left {
  img {
    width: 1.48rem;
  }

  >i {
      color: #FFF;
      font-size: .4rem;
  }
}

.content {
  width: 6.89rem;
  padding: 0.3rem 0 0 0;
  margin: 0 auto;
  background: #ffffff;
  overflow: hidden;
  box-shadow: 0px 2px 10px 0px rgba(54, 54, 54, 0.1);
  border-radius: 20px;
}

.content > .content_hes {
    display: block;
    height: 0.23rem;
    font-size: 0.22rem;
    font-family: PingFang SC;
    font-weight: 500;
    color: #A6A5A5;
    margin-bottom: .6rem;
}

.content_special {
  padding: 0.31rem;
  display: flex;
  flex-wrap: wrap;
}

.content_special > div {
  width: 25%;
}
.content_special .content_special_li {
  /* display: flex; */
  /* height: 1rem; */
  position: relative;
}

.content_special .content_special_li > .fg {
  width: 0.01rem;
  height: 0.6rem;
  background-color: #e1e1e1;
  position: absolute;
  right: 0;
  top: 0;
  bottom: 0;
  margin: auto;
}
.content_special .content_special_li > .fgx {
  width: 2.5rem;
  height: 0.01rem;
  background-color: #e1e1e1;
  position: absolute;
  right: 0;
  left: 0;
  bottom: 0;
  margin: auto;
}
.content_special .content_special_li > div {
  margin-top: 0.1rem;
  text-align: center;
}
.content > h3 {
  font-size: 0.32rem;
  font-weight: bold;
  text-align: center;
  /* margin-top: .29rem; */
  line-height: 0.4rem;
  color: #1e1e1e;
}

.content .content_div {
  display: flex;
  width: 100%;
  margin-top: 0.23rem;
  flex-wrap: wrap;
}

.content .content_div > .content_div_li {
  width: 50%;
  position: relative;
  border: 0.01rem solid #e0e0e0;
  display: flex;
  padding: 0.2rem 0.27rem;
  border-bottom: none;
  border-left: none;
}
.content .content_div > .content_div_li > .fgxoi {
  position: absolute;
  right: 0;
  height: 0.69rem;
  top: 0.08rem;
  width: 0.01rem;
  background-color: #e0e0e0;
}
.content .content_div > .content_div_li_activx {
  width: 100%;
  border-right: none;
}
.content .content_div > .content_div_li:nth-child(2n) {
  border-right: none;
}
.content .content_div > .content_div_li_activx > .content_div_li_activx_span {
  color: #4267ed;
}
.content .content_div > .content_div_li > p {
  font-size: 0.25rem;
  color: #333333;
  /* line-height: 29px; */
}

.content .content_div > .content_div_li > tr > td {
  font-size: 0.24rem;
  color: #333333;
  /* line-height: 29px; */
}
.content .content_div > .content_div_li > tr > td > div {
  font-size: 0.24rem;
  display: block;
  color: #7b7b7b;
  margin-left: 0.31rem;
  position: relative;
  display: flex;
  line-height: 0.5rem;
}
.content .content_div > .content_div_li > span {
  width: 65%;
  font-size: 0.24rem;
  display: block;
  color: #7b7b7b;
  line-height: .4rem;
  margin-left: 0.31rem;
  /* line-height: 29px; */
}
.content .content_div > .content_div_li > div {
  font-size: 0.2rem;
}
.content .content_div > .content_div_li > div > span {
  font-size: 0.22rem;
  display: block;
  color: #7b7b7b;
  margin-left: 0.31rem;
  /* line-height: 29px; */
}
.content .content_div > .content_div_li > a {
  font-size: 0.22rem;
  display: block;
  color: #7b7b7b;
  margin-left: 0.31rem;
  line-height: 29px;
}

.content_div_li > div > .back {
  background-size: 0.24rem 0.25rem;
}

.content_he {
  padding: 0 0.4rem ;
  margin-bottom: .2re;
}

.content_help {
  margin-top: 0.22rem;
}

.content_help > div > i {
  margin-top: 0.1rem;
}
.content_help > div > i {
}
.content_help > div > .back {
  width: 1rem;
  height: 1rem;
  overflow: hidden;
  margin: 0 auto;
  display: block;
  /* background: url(../assets/images/yuang.png) center center no-repeat; */
  /* background-size: 1.88rem 1.88rem; */
  border: .03rem solid #E8E8E8;
    border-radius: 50%;
}

.content_help > div > .back > img {
  margin-top: .2rem !important;
}

.dialog__body {
    h3 {
        font-size: 0.29rem;
        font-weight: 600;
        color: #4b4b4b;
    }
}

.modekskcl {
    width: 0.93rem;
    height: 0.93rem;
    background: rgba(255, 255, 255, 0.9);
    box-shadow: 0rem 0rem 0.133333rem rgba(71, 76, 100, 0.19);
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 0.3rem;
    position: fixed;
    z-index: 999;
    right:.3rem;
    bottom: 4.5rem;
    > span {
        width:.5rem;
        font-size: .18rem;
        color: #545664;
    }
}
</style>
